import { HeaderDesktopContent } from "@faire/deprecated-retailer-visitor-shared/components/Header/desktop/HeaderDesktopContent";
import { LoggedInNavigationLinksBar } from "@faire/deprecated-retailer-visitor-shared/components/Header/desktop/NavigationLinksBar/LoggedInNavigationLinksBar";
import { LoggedOutNavigationLinksBar } from "@faire/deprecated-retailer-visitor-shared/components/Header/desktop/NavigationLinksBar/LoggedOutNavigationLinksBar";
import { HeaderContainer } from "@faire/deprecated-retailer-visitor-shared/components/Header/styled";
import { useIsSemDiscoverPage } from "@faire/deprecated-retailer-visitor-shared/lib/useIsSemDiscoverPage";
import { useIsLoggedInRetailer } from "@faire/marketplace-lib/serialized-data/isLoggedInRetailer";
import React from "react";

export const HeaderDesktop = ({ className }: { className?: string }) => {
  const isLoggedInRetailer = useIsLoggedInRetailer();

  return (
    <HeaderContainer className={className}>
      <HeaderDesktopContent />
      {isLoggedInRetailer ? (
        <LoggedInNavigationLinksBar />
      ) : (
        <MaybeLoggedOutNavigationLinksBar />
      )}
    </HeaderContainer>
  );
};

const MaybeLoggedOutNavigationLinksBar: React.FC = () => {
  const isSemDiscoverPage = useIsSemDiscoverPage();
  return isSemDiscoverPage ? null : <LoggedOutNavigationLinksBar />;
};
